interface ILocalStorageCredentials {
  accessToken: string;
  idToken: string;
  refreshToken: string;
}

export const setUserCredentials = (payload: ILocalStorageCredentials) => {
  localStorage.setItem("DXUSER", JSON.stringify(payload));
};
